import { List as IList, Map as IMap } from 'immutable';

export const selectProductComments = (state) => state.commentsReducer.get('comments', IList());
export const selectTotalItems = (state) => state.commentsReducer.get('totalItems', 0);
export const selectQueryData = (state) => state.commentsReducer.get('queryData', IMap());
